
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller/[...slug]",
      function () {
        return require("private-next-pages/seller/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seller/[...slug]"])
      });
    }
  